import React, { useRef } from 'react';
import { SidebarProps } from './sidebar.props';
import useOnClickOutside from 'use-onclickoutside';
import { CSSTransition } from 'react-transition-group';
import { useSidebarStyles } from './sidebar.styles';
import { SidebarType } from './sidebar-type.enum';
import { CloseIconMolecule } from '../../molecules/close-icon';

export const SidebarOrganism = (props: SidebarProps) => {
  const sidebarAlignment =
    props.type === SidebarType.LEFT ? 'left-0' : 'right-0';
  const closeIconAlignment =
    props.type === SidebarType.LEFT ? 'left-5' : 'right-5';

  const ref = useRef(null);
  useOnClickOutside(ref, props.closeSidebar);
  const classes = useSidebarStyles(props.type)();

  return (
    <>
      <CSSTransition
        in={props.opened}
        timeout={250}
        classNames={'menu-transition'}
      >
        <section
          data-cy="sidebar-organism"
          ref={ref}
          className={`fixed top-0 ${sidebarAlignment} h-full  bg-white z-50 p-6 box-border shadow w-80 ${classes['menu-transition']} ${props.className}`}
        >
          {props.showCloseIcon && (
            <CloseIconMolecule
              close={props.closeSidebar}
              className={`absolute ${closeIconAlignment} top-5`}
            />
          )}
          {props.children}
        </section>
      </CSSTransition>
      <CSSTransition
        mountOnEnter
        unmountOnExit
        in={props.opened}
        timeout={250}
        classNames={'bg-layer-transition'}
      >
        <div
          className={`bg-layer cursor-pointer fixed z-10 top-0 left-0 w-full h-full bg-black ${classes['bg-layer-transition']}`}
        />
      </CSSTransition>
    </>
  );
};

SidebarOrganism.defaultProps = {
  type: SidebarType.LEFT,
  showCloseIcon: true,
};
